import { Component, TemplateRef, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AuthService } from 'src/app/shared/service/auth/auth.service';
import { FecthDataService } from 'src/app/shared/service/fetchservice/fetchservice';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { AddAdministrateursComponent } from '../../administrateur/add-administrateurs/add-administrateurs.component';
import { UpdateAdministrateurComponent } from '../../administrateur/update-administrateur/update-administrateur.component';

@Component({
  selector: 'app-log',
  standalone: false,
  templateUrl: './log.component.html',
  styleUrl: './log.component.scss'
})

export class LogComponent {

  items: any = [];
  user_reference: any;
  paginatedItems = [];
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;
  isLoading: boolean = false;
  searchTerm: string;
  filteredtems: any = [];
  searchDate: string = '';
  dateDebut: string = '';
  dateFin: string = '';
  searchGender: string = '';
  isDisabled: boolean = false;
  @ViewChild('modalContent') modalContent: TemplateRef<any>;
  displaySuspendDialog: boolean = false;
  suspendReason: string = '';
  private selectedForSuspend: any;
  selectedSupend: any;

  // Pour rejet
  displayRejectDialog = false;
  rejectReason = '';
  private selectedForReject: any;
  constructor(

    private modalService: NgbModal,
    private localstorage: LocalStorageService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private ngxService: NgxUiLoaderService,
    private router: RouterModule,
    private FecthDataService: FecthDataService,
    private paramService: ParameterService,
    private authService: AuthService


  ) {
    this.user_reference = this.localstorage.getUsers().data.reference;
    console.log("this.user_reference", this.user_reference);
    this.FecthDataService.actionCreated$.subscribe(() => {
      // Met à jour la liste après la création réussie d'un glossaire
      this.getLogUsers();
    });
  }

  ngOnInit() {

  }
  openModal() {
    this.modalService.open(AddAdministrateursComponent, {
      centered: true,
      backdrop: 'static',
      size: 'xl'
    });
  }

  editOpenModal(item: any) {
    this.localstorage.saveAdministrateur(item);
    this.modalService.open(UpdateAdministrateurComponent, {
      centered: true,
      backdrop: 'static',
      size: 'xl'
    });
  }


  getLogUsers() {
    this.isLoading = true;

    this.authService.getLogUsers(this.user_reference).subscribe(
      (response: any) => {
        this.isLoading = false;
        this.items = response.data;
        this.filteredtems = this.items;
        this.totalRecords = this.items.length; // Met à jour le total des enregistrements
        this.updatePaginated();

        console.log("la reponse du webservice", this.items);

      },
      (error) => {
        console.log("une erreu est survenu", error);

      }
    )
  }
  onPageChange(event) {
    this.first = event.first; // Mise à jour de la page actuelle
    this.rows = event.rows; // Mise à jour de la page actuelle
    this.updatePaginated();
  }

  // Méthode pour mettre à jour les données paginées des projets
  updatePaginated() {
    const start = this.first;
    const end = start + this.rows;
    this.paginatedItems = this.filteredtems.slice(start, end);
  }




  prepareSuspend(item: any) {
    this.selectedForSuspend = item;
    this.suspendReason = '';
    this.displaySuspendDialog = true;
  }

  // si annulation
  onCancelSuspend() {
    this.displaySuspendDialog = false;
    this.selectedForSuspend = null;
    this.suspendReason = '';
  }
 


  //


  
  //end
  filterBySearchTerm() {
    if (!this.searchTerm) {
      this.filteredtems = this.items; // Si la recherche est vide, affiche tous les éléments
    } else {
      const search = this.searchTerm.toLowerCase();

      this.filteredtems = this.items.filter(item =>
        (item?.nom && item.nom.toLowerCase().includes(search)) ||
        (item?.prenom && item.prenom.toLowerCase().includes(search)) ||
        (item?.email && item.email.toLowerCase().includes(search)) ||
        (item?.telephone && item.telephone.toLowerCase().includes(search))
      );
    }

    this.updatePaginated(); // Mise à jour de la pagination après filtrage
  }

  getLibelleStatut(statut: string): string {
    switch (statut) {
      case 'valide':
        return 'Actif';
      case 'suspens':
        return 'Suspendu';
      case 'pending':
        return 'En attente de validation';
         case 'rejet':
        return 'Rejeté';
      default:
        return 'Statut inconnu';
    }
  }

}
